import styled from 'styled-components';
import { SuiContainer } from '@splashthat/sui';
import { colorAppError } from 'common/styles/colors';

export const RecaptchaContainer = styled(SuiContainer)`
    display: flex;
    justify-content: center;
    margin: 2.5rem 0;
    width: 100%;
`;

export const SubmitButtonContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 1rem 0;
`;

export const InputContainer = styled.div`
    margin-bottom: 1rem;

    .SuiField {
        border-color: ${({ theme }) => theme.palette.grayscale.gray50};

        &:focus-within {
            border-color: ${({ theme }) => theme.palette.primary.main};
        }
    }
`;

export const HeaderText = styled.h2`
    text-align: center;
    margin: 2rem;
    font-size: 1.5rem;
`;

export const Asterisk = styled.span`
    color: ${colorAppError};
`;
